<template>
  <AlertInfo />
</template>

<script>
export default {
  name: "AlertInfoPage",

  routing: {
    routeName: "AlertInfoPage",
    path: "/alerts/:id",
    hasAccess: (user) => user.isSuperAdmin,
  },

  components: {
    AlertInfo: () => import("../components/alerts/AlertInfo.vue"),
  },
};
</script>

<style scoped>

</style>
